// src/pages/Categories/components/CategoryForm.tsx
import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import type { Category } from '../../../types/@types/category'
import { Plus, Save, X } from 'lucide-react'

interface CategoryFormProps {
  category: Category | null
  onSubmit: (category: Omit<Category, 'id'>) => void
  onCancel?: () => void
}

const CategoryForm: React.FC<CategoryFormProps> = ({ category, onSubmit, onCancel }) => {
  const [name, setName] = useState(category ? category.name : '')
  const [icon, setIcon] = useState(category ? category.icon : '')

  useEffect(() => {
    setName(category ? category.name : '')
    setIcon(category ? category.icon : '')
  }, [category])

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!name || !icon) {
      toast.error('Todos los campos son requeridos')
      return
    }
    onSubmit({ name, icon })
    if (!category) {
      setName('')
      setIcon('')
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-1.5">
        <label className="block text-sm font-medium text-text" htmlFor="cat-name">
          Nombre
        </label>
        <input
          id="cat-name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Ej: Bebidas, Postres…"
          className="block w-full rounded-xl border border-border bg-muted px-4 py-3 text-sm text-text placeholder:text-text-muted focus:border-primary focus:bg-surface focus:outline-none focus:ring-2 focus:ring-primary/20 transition-all"
        />
      </div>

      <div className="space-y-1.5">
        <label className="block text-sm font-medium text-text" htmlFor="cat-icon">
          Ícono <span className="ml-1 font-normal text-text-muted">(emoji)</span>
        </label>
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl border border-border bg-muted text-2xl">
            {icon || '?'}
          </div>
          <input
            id="cat-icon"
            type="text"
            value={icon}
            onChange={(e) => setIcon(e.target.value)}
            placeholder="🍕"
            className="flex-1 rounded-xl border border-border bg-muted px-4 py-3 text-sm text-text placeholder:text-text-muted focus:border-primary focus:bg-surface focus:outline-none focus:ring-2 focus:ring-primary/20 transition-all"
          />
        </div>
      </div>

      <div className="flex gap-3 pt-2">
        <button
          type="submit"
          className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-primary py-3 text-sm font-semibold text-primary-fg shadow-md transition-all duration-200 hover:opacity-90 active:scale-[0.98]"
        >
          {category ? <Save size={16} /> : <Plus size={16} />}
          {category ? 'Actualizar' : 'Crear'}
        </button>
        {category && onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="flex items-center justify-center gap-2 rounded-xl border border-border bg-muted px-4 py-3 text-sm font-semibold text-text-muted transition-all duration-200 hover:bg-danger/10 hover:text-danger active:scale-[0.98]"
          >
            <X size={16} />
            <span className="sr-only sm:not-sr-only">Cancelar</span>
          </button>
        )}
      </div>
    </form>
  )
}

export default CategoryForm
